import styled from 'styled-components'

export const CategoryDescription = styled('p')`
  font-size: 16px;
  font-weight: 400;
  margin: 0px;
`

export const Flex = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 22px;
`